import { render } from "./SubLoginForm.vue?vue&type=template&id=d88ad366"
import script from "./SubLoginForm.vue?vue&type=script&lang=js"
export * from "./SubLoginForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__